<div class="photos-step">
  <div class="row">
    <div class="col-12">
      <!-- Step 1: Private Photos -->
      <div *ngIf="currentStep === 'private'" class="step-content">
        <h4 class="mb-4">Private Photos</h4>

        <div class="alert alert-warning d-flex align-items-start">
          <i class="icon-info mr-2 mt-1"></i>
          <div>
            <strong>Important:</strong> These photos are required for verification purposes only and will not be displayed on your listing. Can be added later.
          </div>
        </div>

        <common-inventory-images-private
          [inventoryItem]="getInventoryItem()"
          [hideInlineVerificationHint]="true"
        >
        </common-inventory-images-private>

        <div class="text-center mt-4">
          <button type="button" class="btn btn-success btn-lg" (click)="proceedToListingPhotos()">
            Continue to Listing Photos
            <i class="icon-arrow-right ml-2"></i>
          </button>
        </div>
      </div>

      <!-- Step 2: Listing Photos -->
      <div *ngIf="currentStep === 'listing'" class="step-content">
        <p class="mb-4 text-muted">
          Use your smartphone to take high quality photos of your machine in horizontal/landscape format. Make sure photos are
          taken from at least 20 feet away to capture the entire machine, including both sides and corner angles. Effective
          photos will increase listing visibility and attract more renters and buyers.
        </p>

        <common-inventory-images
          [inventoryItem]="getInventoryItem()"
          [showAdminActions]="false"
          [allowBatchUpload]="true"
          (imageUploaded)="onListingImageUploaded($event)"
        >
        </common-inventory-images>

        <div class="text-center mt-4">
          <button type="button" class="btn btn-success btn-lg" (click)="onFinish()" [disabled]="!canProceed() || loading">
            <span *ngIf="loading" class="spinner-border spinner-border-sm mr-2"></span>
            {{ loading ? "Saving..." : "Finish & Publish" }}
          </button>

          <div class="mt-3">
            <button type="button" class="btn btn-link text-success" (click)="goBackToPrivatePhotos()">
              <i class="icon-arrow-left mr-1"></i>
              Back to Private Photos
            </button>
          </div>
        </div>
      </div>

      <!-- Navigation Buttons (only show when on private step) -->
      <div *ngIf="currentStep === 'private'" class="text-center mt-4">
        <button type="button" class="btn btn-link text-success" (click)="onBack()" [disabled]="loading">
          <i class="icon-arrow-left mr-1"></i>
          Back to Attachments
        </button>
      </div>

      <!-- Validation Messages -->
      <div class="alert alert-danger mt-3" *ngIf="validationErrors.length > 0">
        <ul class="mb-0">
          <li *ngFor="let error of validationErrors">{{ error }}</li>
        </ul>
      </div>
    </div>
  </div>

  <!-- Photo Preview Modal -->
  <div class="modal fade" id="photoPreviewModal" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Photo Preview</h5>
          <button type="button" class="close" data-dismiss="modal">
            <span>&times;</span>
          </button>
        </div>
        <div class="modal-body text-center">
          <img [src]="previewPhotoUrl" [alt]="'Photo preview'" class="img-fluid" />
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</div>
